/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Prep_Moment_EveningInputs */



/**
* | output |
* | --- |
* | "The evening before" |
*
* @param {Notifications_Prep_Moment_EveningInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const notifications_prep_moment_evening = /** @type {((inputs?: Notifications_Prep_Moment_EveningInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Prep_Moment_EveningInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De avond ervoor")
	if (locale === "fr") return /** @type {LocalizedString} */ ("La veille au soir")
	return /** @type {LocalizedString} */ ("The evening before")
});